import { render, staticRenderFns } from "./CallPagination.vue?vue&type=template&id=61f67046"
import script from "./CallPagination.vue?vue&type=script&lang=js"
export * from "./CallPagination.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports